import React from "react";

const Contact = () => {
  return (
    <section id="contact-page" className="py-2">
      <div className="container">
        <div className="two-card-container">
          <article className="card">
          <h2>Contact Us</h2>
            <div className="contact-details">
              <h3>Location</h3>
              <p>122 Orange Grove, Auburn, Wellington 5034</p>
              <h3>Phone</h3>
              <p>027 600 2442</p>
              <h3>Email</h3>
              <p>info@pedresflooring.com</p>
            </div>
          </article>
          <article className="card">Map here</article>
        </div>
      </div>
    </section>
  );
};

export default Contact;
